import { useScrollReveal } from '@/hooks/useScrollReveal';

const items = [
  'Not a law firm, and not a source of legal advice',
  'Not a compliance certification, and not a guarantee that any use satisfies Law Society obligations',
  'Not a replacement for professional judgment',
  'Not a replacement for Clio or your system of record',
  'Not a legal research database',
  'Not an autonomous agent',
  'Not a finished self-serve product. It is a working prototype deployed through implementation, and it currently requires a desktop workspace and technical setup',
];

const LegalNotThis = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      ref={ref}
      data-testid="legal-notthis-section"
      className={`legal-section section-reveal ${isVisible ? 'visible' : ''}`}
    >
      <div className="legal-content">
        <h2 className="legal-h2" data-testid="legal-notthis-h2">
          What Soundboard Matter is not
        </h2>

        <ul className="legal-plain-list mt-8" data-testid="legal-notthis-list">
          {items.map((item, i) => (
            <li key={`not-${i}`} data-testid={`legal-notthis-item-${i}`}>{item}</li>
          ))}
        </ul>

        <p className="legal-body mt-8" data-testid="legal-notthis-closing">
          These exclusions are the reason the rest of the page can be taken at face value.
        </p>
      </div>
    </section>
  );
};

export default LegalNotThis;
